"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Jackpot = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _JackpotModule = _interopRequireDefault(require("./Jackpot.module.css"));
var _excluded = ["data", "solid", "currency", "scale"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Jackpot = function Jackpot(_ref) {
  var data = _ref.data,
    solid = _ref.solid,
    currency = _ref.currency,
    scale = _ref.scale,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: (0, _classnames.default)(_JackpotModule.default.container, solid && _JackpotModule.default.solid),
    style: {
      '--scale': scale
    }
  }, data.toString().split('').map(function (letter, index) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: index,
      className: letter === '.' ? _JackpotModule.default.dot : null
    }, letter !== '.' ? letter : '');
  }), currency.show && /*#__PURE__*/_react.default.createElement("li", {
    className: _JackpotModule.default.currency,
    style: {
      color: currency.color
    }
  }, currency.label));
};
exports.Jackpot = Jackpot;
Jackpot.propTypes = {
  data: _propTypes.default.number,
  solid: _propTypes.default.bool,
  currency: _propTypes.default.object,
  scale: _propTypes.default.number
};
Jackpot.defaultProps = {
  data: 23471.25,
  solid: true,
  currency: {
    show: true,
    label: 'GEL',
    color: '#ffca2c'
  },
  scale: 1
};